module.exports = __webpack_public_path__ + "assets/media/lunch.7a5f2f6f.mp3";